var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFullscreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_fullscreen",
    transform: "translate(-1586 -196)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2930",
    "data-name": "Rectangle 2930",
    width: 24,
    height: 24,
    transform: "translate(1586 196)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6702",
    "data-name": "Path 6702",
    d: "M4579.375,335a.376.376,0,0,1-.374-.375v-1.251a.376.376,0,0,1,.374-.375H4582v-2.624a.376.376,0,0,1,.375-.375h1.25a.376.376,0,0,1,.375.375v3.875a.749.749,0,0,1-.75.75Zm-8.625,0a.749.749,0,0,1-.75-.75v-3.875a.376.376,0,0,1,.375-.375h1.25a.376.376,0,0,1,.375.375V333h2.625a.376.376,0,0,1,.375.375v1.251a.376.376,0,0,1-.375.375Zm11.625-9a.377.377,0,0,1-.375-.375V323h-2.625a.376.376,0,0,1-.374-.375v-1.251a.376.376,0,0,1,.374-.375h3.875a.749.749,0,0,1,.75.75v3.876a.377.377,0,0,1-.375.375Zm-12,0a.376.376,0,0,1-.375-.375V321.75a.749.749,0,0,1,.75-.75h3.876a.376.376,0,0,1,.375.375v1.251a.376.376,0,0,1-.375.375H4572v2.625a.376.376,0,0,1-.375.375Z",
    transform: "translate(-2979 -120)",
    fill: "#171c28"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFullscreen);
export default __webpack_public_path__ + "static/media/icon_fullscreen.eb7932c3.svg";
export { ForwardRef as ReactComponent };